import(/* webpackMode: "eager" */ "/app/app/page.jsx")